/* eslint-disable */
export const mailRegex =
  /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
/* eslint-enable */

/*
  phoneRegex Valid formats:
   +330610203040
   0610203040
   06 10 20 30 40
*/
export const phoneRegex =
  /(?:(?:\+|00)33[\s.-]{0,3}(?:\(0\)[\s.-]{0,3})?|0)[1-9](?:(?:[\s.-]?\d{2}){4}|\d{2}(?:[\s.-]?\d{3}){2})$/g;

/*
  passwordRegex Valid formats:
  - At least 8 characters
  - At least one uppercase letter
  - At least one lowercase letter
  - At least one number
  - At least one special character
*/
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

/*
  postalCodeRegex Valid formats:
  - Matches valid French postal codes.
  - Must be exactly 5 digits.
  - Starts with:
    - 01 to 95 (mainland French departments)
    - or 97, 98 (overseas departments and territories)
  - Ensures the structure complies with official French postal code ranges.
*/
export const postalCodeRegex = /^(0[1-9]|[1-8]\d|9[0-5]|97|98)\d{3}$/;

/*
  noOnlySpacesRegex Valid formats:
  - Rejects empty strings or strings made of only whitespace characters.
  - Accepts any string containing at least one non-whitespace character.
  - Useful to ensure required fields are not filled with just spaces.
*/
export const noOnlySpacesRegex = /^(?!\s*$).+/;
